export const casinoLink: string = '/casino/';
